import { render } from "./page-header.vue?vue&type=template&id=36b90e1e&scoped=true"
import script from "./page-header.vue?vue&type=script&lang=js"
export * from "./page-header.vue?vue&type=script&lang=js"

import "./page-header.vue?vue&type=style&index=0&id=36b90e1e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86131\\Desktop\\睿捷项目\\face-pro-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b90e1e"]])

export default __exports__